import "./LoaderBouncing.css"
// For boncing loader
const ThreeDotBouncingLoader = () => (
  <span className="loader"></span>
);

export default ThreeDotBouncingLoader;
